// components/menuItem/MenuItem.jsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

const MenuItemFresha = ({
  item,
  onClick,
  isSelected,
  highlightMatch,
  searchTerm,
}) => {
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart.cart);

  const matchingItems = cart.filter((c) => c._id === item._id);

  const selectedOptions = matchingItems.map((c) => c.selectedOption);

  const itemCountInCart = matchingItems.reduce(
    (total, c) => total + c.count,
    0,
  );

  const isItemInCart = itemCountInCart > 0;

  if (!item) return null; // 🔥 prevent crash

  return (
    <div
      onClick={onClick}
      className={`relative w-full flex justify-between shadow-md  items-center gap-4 p-4 rounded-xl transition-all cursor-pointer
        ${
          isItemInCart
            ? "border border-navy bg-navy text-neonYellow"
            : " border border-gray-300 hover:bg-gray-300 "
        }`}
    >
      <div className="flex-1 sm:pr-4">
        <p
          className={`text-base sm:text-md font-semibold ${
            isItemInCart ? "text-neonYellow" : ""
          }`}
        >
          {/* {item.title} */}
          {highlightMatch
            ? highlightMatch(item.title, searchTerm)
            : item.title}{" "}
          {/* Show selected options ONLY if item has subdesc */}
          {isItemInCart &&
            item.subdesc &&
            item.subdesc.length > 0 &&
            selectedOptions.length > 0 && (
              <div className="mt-2 text-xs text-amber-600 font-semibold space-y-2 mb-2">
                {selectedOptions.map((option, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 text-yellowstar animate-neonFlicker"
                  >
                    <CheckCircleIcon className="w-4 h-4 text-yellowstar " />
                    <span>{option}</span>
                  </div>
                ))}
              </div>
            )}
        </p>
        <p
          className={`text-sm  ${isItemInCart ? "text-textGray" : "text-textGray"}`}
        >
          {item.desc || " "}
        </p>

        <p
          className={`text-sm mt-2  ${isItemInCart ? "text-darkbg" : "text-navy"}`}
        >
          ${item.price}
          {item.discount && (
            <span className="text-green-600 text-sm font-semibold ml-2">
              Save {item.discount}
            </span>
          )}
        </p>
        {isItemInCart && (
          <div className="absolute top-0 right-0 w-6 h-6 bg-neonYellow border border-border text-white text-xs font-semibold rounded-tr-lg flex items-center justify-center">
            {itemCountInCart}
          </div>
        )}
      </div>

      <div className="mt-1">
        {isItemInCart ? (
          <div className="w-6 h-6 bg-neonYellow rounded-md flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={5}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        ) : (
          <div className="w-6 h-6 border border-textGray rounded-md" />
        )}
      </div>
    </div>
  );
};

export default MenuItemFresha;
